import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setToogleHeader } from "../../../core/redux/action";
import { ArrowLeft, ChevronUp, Info } from "react-feather";
import { all_routes } from "../../../Router/all_routes";
import { useEffect } from "react";
import apiHandler from "../../common/api";
import { Country, State, City } from "country-state-city";
import Select from "react-select";
import LoadingSpinner from "../../../InitialPage/Sidebar/LoadingSpinner";

function ZipCodeMaster() {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const userData = useSelector((state) => state.user_data);
  const navigate = useNavigate();
  const routes = all_routes;
  const allCountries = Country.getAllCountries();
  const zipCodeId = useParams()?.id || 0;

  const [options, setOptions] = useState({
    gender: [],
    countries: allCountries.map((c) => ({
      value: c.name,
      label: c.name,
    })),
  });

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const [formData, setFormData] = useState({
    id: 0,
    country: "",
    state: "",
    city: "",
    zipCode: "",
    isActive: false,
    CountryError: "",
    StateError: "",
    CityError: "",
    ZipCodeError: "",
  });

   const [loading, setLoading] = useState(false);

  const getCustomerDetails = async (zipCodeId) => {
    const response = await apiHandler({
      method: "GET",
      route: `Superadmin/ModuleFindId?Module=zipCodeMaster&ID=${zipCodeId}`,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setFormData({...response.ResponseData[0]});
    } else {
      console.log(response, "data");
    }
  };

  useEffect(() => {
    if (zipCodeId > 0) {
      getCustomerDetails(zipCodeId);
    }
  }, [zipCodeId]);

  useEffect(() => {
    if (formData.country) {
      const statesData = State.getStatesOfCountry(
        allCountries.find((c) => c.name === formData.country)?.isoCode
      );
      setOptions((prev) => ({
        ...prev,
        states: statesData.map((s) => ({
          value: s.name,
          label: s.name,
        })),
      }));

      // If editing with a pre-filled state, fetch cities right away
      if (formData.state) {
        const cities = City.getCitiesOfState(
          allCountries.find((c) => c.name === formData.country)?.isoCode,
          statesData.find((s) => s.name === formData.state)?.isoCode
        );

        setOptions((prev) => ({
          ...prev,
          cities: cities.map((c) => ({
            value: c.name,
            label: c.name,
          })),
        }));
      }
    }
  }, [formData.country, formData.state]);

  console.log(formData, "formData");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    if (e) {
      setFormData((prevState) => ({
        ...prevState,
        [name]: checked,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
     // Reset error messages before starting validation
  setFormData((prevState) => ({
    ...prevState,
    CountryError: "",
    StateError: "",
    CityError: "",
    ZipCodeError: "",
  }));

  // Validate first name and last name
  let hasError = false;

  if (!formData.country.trim()) {
    setFormData((prevState) => ({
      ...prevState,
      CountryError: "Country is required.",
    }));
    hasError = true;
  }

  if (!formData.state.trim()) {
    setFormData((prevState) => ({
      ...prevState,
      StateError: "State is required.",
    }));
    hasError = true;
  }

  if (!formData.city.trim()) {
    setFormData((prevState) => ({
      ...prevState,
      CityError: "City is required.",
    }));
    hasError = true;
  }

  if (!formData.zipCode.trim()) {
    setFormData((prevState) => ({
      ...prevState,
      ZipCodeError: "Postcode is required.",
    }));
    hasError = true;
  }

  if (hasError) {
    setLoading(false);
    return; // Stop the form submission if there's an error
  }

    setLoading(true);
    console.log("Form Data Submitted:", formData);

    const response = await apiHandler({
      method: "POST",
      route: `Superadmin/zipCodeMasterUpsert`,
      payload: { ...formData, loginuserid: userData?.id },
    });
    if (response.ResponseCode === "SUCCESS") {
      setLoading(false);
      handleCancle();
    } else {
      setLoading(false);
      console.log(response, "data");
    }
  };

  const handleCancle = () => {
    navigate(routes.zipCodeList);
    setFormData({
      id: 0,
      country: "",
      state: "",
      city: "",
      zipCode: "",
      isActive: false,
    });
  };

  console.log(options, "optionsList");

  return (
    <>
    <LoadingSpinner isLoading={loading} />
    <div className="mt-5">
      <div className="page-wrapper  pt-0">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>ZipCodeMaster</h4>
                <h6>Manage ZipCodeMaster</h6>
              </div>
            </div>

            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <div className="page-btn">
                  <button
                    onClick={() => navigate(all_routes.zipCodeList)}
                    className="btn btn-primary btn-md btn-wave me-2"
                  >
                    <ArrowLeft className="me-2" />
                    Back to ZipCodeMaster
                  </button>
                </div>
              </li>
            </ul>
          </div>

          <div className="">
            <div className="">
              <div className="accordion" id="accordionPanelsStayOpenExample">
                <div className="accordion-item show">
                  <h2
                    className="accordion-header"
                    id="panelsStayOpen-headingOne"
                  >
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseOne"
                      aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseOne"
                    >
                      <div className="card-title-head">
                        <h6 className="m-0 p-0" style={{ border: "none" }}>
                          <span>
                            <Info className="feather-edit" />
                          </span>
                          ZipCodeMaster Information
                        </h6>
                      </div>
                    </button>
                  </h2>
                  <div
                    id="panelsStayOpen-collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingOne"
                  >
                    <div className="accordion-body">
                      <div className="w-100 col-12">
                        {/* City, State, Country Row */}

                        <div className="row mb-2">
                          <div className="form-group col-xl-4 col-md-6 col-12">
                            <label className="text-sm-medium">Country</label>
                            <Select
                              classNamePrefix="react-select"
                              placeholder="Select Country"
                              options={options?.countries}
                              value={options?.countries?.find(
                                (el) => el.value == formData?.country
                              )}
                              onChange={(e) =>
                                handleChange({
                                  target: { name: "country", value: e.value },
                                })
                              }
                            />
                                                          {formData.CountryError && (
                               <div className="text-danger">{formData.CountryError}</div>
                              )}
                          </div>

                          <div className="form-group col-xl-4 col-md-6 col-12">
                            <label className="text-sm-medium">State</label>
                            <Select
                              classNamePrefix="react-select"
                              placeholder="Select State"
                              options={options?.states}
                              value={options?.states?.find(
                                (el) => el.value == formData?.state
                              )}
                              onChange={(e) =>
                                handleChange({
                                  target: { name: "state", value: e.value },
                                })
                              }
                            />
                                                                                      {formData.StateError && (
                               <div className="text-danger">{formData.StateError}</div>
                              )}
                          </div>
                          <div className="form-group col-xl-4 col-md-6 col-12">
                            <label className="text-sm-medium">City</label>
                            <Select
                              classNamePrefix="react-select"
                              placeholder="Select City"
                              options={options?.cities}
                              value={options?.cities?.find(
                                (el) => el.value == formData?.city
                              )}
                              onChange={(e) =>
                                handleChange({
                                  target: { name: "city", value: e.value },
                                })
                              }
                            />
                             {formData.CityError && (
                               <div className="text-danger">{formData.CityError}</div>
                              )}
                          </div>
                        </div>
                        <div className="row mb-2">
                          <div className="form-group col-xl-4 col-md-6 col-12">
                            <label className="text-sm-medium">Postcode</label>
                            <input
                              className="form-control"
                              type="text"
                              name="zipCode"
                              placeholder="Select Postcode"
                              value={formData.zipCode}
                              onChange={handleChange}
                            />
                            {formData.ZipCodeError && (
                               <div className="text-danger">{formData.ZipCodeError}</div>
                              )}
                          </div>
                          <div className="form-group col-xl-4 col-md-6 col-12 d-flex align-items-center">
                            <label className="form-label mb-0">isActive: </label>
                            <input
                              type="checkbox"
                              name="isActive"
                              checked={formData.isActive}
                              onChange={handleCheckboxChange}
                              style={{marginLeft:"4px"}}
                              className="custome-boder form-check-input"
                            />
                          </div>
                        </div>
                        {/* <div className="row mb-2">
                          <div className="mb-3 add-product">
                            <label className="form-label">isActive: </label>
                            <input
                              type="checkbox"
                              name="isActive"
                              checked={formData.isActive}
                              onChange={handleCheckboxChange}
                              className="ms-2"
                            />
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Add Action Buttons */}
              <div className="col-lg-12 col-md-12 col-12 mt-4">
                <div className="btn-addproduct mb-4">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-md me-2"
                    onClick={handleCancle}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-primary btn-md btn-wave me-2"
                    onClick={(e) => handleSubmit(e)}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default ZipCodeMaster;
